











import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CzCard extends Vue {
  @Prop({ type: [String, Object], default: "" }) to!: string | object;
  @Prop({ type: String, default: "div" }) tag!: string;
  @Prop({ type: Boolean, default: true }) padded!: boolean;
  @Prop({ type: Boolean, default: false }) flat!: boolean;
}
